import { useState } from "react";
import { act, flash, post } from "../lib/api";
import { Sheet } from "./bits";
import { problem } from "./SignIn";

export function ChangePasswordSheet({ onClose }) {
  const [a, setA] = useState("");
  const [b, setB] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  async function save(e) {
    e.preventDefault();
    const p = problem(a, b);
    if (p) return setErr(p);
    setBusy(true);
    const r = await post("/auth/change-password", { newPassword: a, confirm: b });
    setBusy(false);
    if (!r.ok) return setErr(r.status === 0 || r.status >= 500 ? "Could not change it. Try again." : r.error.message);
    flash(r.data.message);
    onClose();
  }
  return (
    <Sheet title="Change password" onClose={onClose} testid="change-password-sheet" width={420}>
      <form onSubmit={save}>
        <label className="fld-lbl" htmlFor="cp-a">New password</label>
        <input id="cp-a" className="fld" type="password" autoComplete="new-password" maxLength={72} autoFocus value={a}
          onChange={(e) => { setA(e.target.value); setErr(""); }} data-testid="change-password-new" />
        <label className="fld-lbl" htmlFor="cp-b">Type it again</label>
        <input id="cp-b" className="fld" type="password" autoComplete="new-password" maxLength={72} value={b}
          onChange={(e) => { setB(e.target.value); setErr(""); }} data-testid="change-password-again" />
        <p className="hint">At least 8 characters.</p>
        {err && <p className="err" role="alert" data-testid="change-password-error">{err}</p>}
        <div className="cs-actions">
          <button className="btn-solid" disabled={busy} data-testid="change-password-save">Change password</button>
          <button type="button" className="btn-ghost sm" onClick={onClose} data-testid="change-password-cancel">Cancel</button>
        </div>
      </form>
    </Sheet>
  );
}

const WORDS = ["mango", "kite", "chai", "tiffin", "monsoon", "rickshaw", "masala", "lotus", "tabla", "jalebi", "pixel", "tempo"];

export function suggestPassword() {
  const r = new Uint32Array(3);
  crypto.getRandomValues(r);
  return `${WORDS[r[0] % WORDS.length]}-${1000 + (r[1] % 9000)}-${WORDS[r[2] % WORDS.length]}`;
}

export function ResetPasswordSheet({ person, onClose }) {
  const [pw, setPw] = useState(suggestPassword);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [copied, setCopied] = useState(false);
  async function save(e) {
    e.preventDefault();
    const r = await post(`/people/${person.id}/reset-password`, { password: pw });
    if (!r.ok) return setErr(r.error.message);
    await act(Promise.resolve(r));
    setDone(true);
  }
  return (
    <Sheet title="Reset password" onClose={onClose} testid="reset-password-sheet">
      {!done ? (
        <form onSubmit={save}>
          <p className="hint">Set a new password for <b>{person.name}</b>, then send it to them yourself (WhatsApp or in person). Their old password stops working.</p>
          <label className="fld-lbl" htmlFor="rp-pw">New password</label>
          <input id="rp-pw" className="fld mono" maxLength={72} value={pw} autoComplete="off" spellCheck={false}
            onChange={(e) => { setPw(e.target.value); setErr(""); }} data-testid="reset-password-input" />
          <button type="button" className="link sm" onClick={() => setPw(suggestPassword())} data-testid="reset-password-suggest">Suggest another</button>
          {err && <p className="err" role="alert" data-testid="reset-password-error">{err}</p>}
          <div className="cs-actions">
            <button type="submit" className="btn-primary" data-testid="reset-password-save">Set password</button>
            <button type="button" className="btn-ghost sm" onClick={onClose} data-testid="reset-password-cancel">Cancel</button>
          </div>
        </form>
      ) : (
        <div data-testid="reset-password-done">
          <p className="hint">Done. Send {person.short} this password. They choose their own the next time they sign in.</p>
          <div className="fix">
            <input readOnly className="fld mono" value={pw} onFocus={(e) => e.currentTarget.select()} aria-label={`New password for ${person.name}`} data-testid="reset-password-show" />
            <button className="btn-ghost sm" onClick={() => { navigator.clipboard?.writeText(pw); setCopied(true); }} data-testid="reset-password-copy">{copied ? "Copied" : "Copy"}</button>
          </div>
          <div className="cs-actions"><button className="btn-ghost sm" onClick={onClose} data-testid="reset-password-close">Close</button></div>
        </div>
      )}
    </Sheet>
  );
}

export function RemoveSheet({ person, onClose, onConfirm }) {
  return (
    <Sheet title="Remove from the team" onClose={onClose} testid="remove-sheet">
      <p className="hint"><b>{person.name}</b> leaves CK. Their open cards go to the request tray, they can no longer sign in, and their logged hours stay with the clients. You can restore them later.</p>
      <div className="cs-actions">
        <button className="btn-ghost sm danger" onClick={onConfirm} data-testid="remove-confirm">Remove {person.short}</button>
        <button className="btn-ghost sm" onClick={onClose} data-testid="remove-cancel">Cancel</button>
      </div>
    </Sheet>
  );
}
